import type {TRPCLink} from '@trpc/client';
import type {AnyRouter} from '@trpc/server';
import {prefixRulesPrompt} from './rulesSystem';

// Apply the rules at the API boundary so every prompt uses the current selection.
export const rulesPromptLink: TRPCLink<AnyRouter> = () => ({op, next}) => {
  const input = op.input;
  if (op.type === 'mutation' && input && typeof input === 'object' && 'message' in input) {
    const message = (input as {message: unknown}).message;
    if (typeof message === 'string') {
      return next({...op, input: {...input, message: prefixRulesPrompt(message)}});
    }
  }
  return next(op);
};
